import Chart from 'react-apexcharts';

function StackedBarChart({
  title = '',
  categories = [],
  series = [],
  width = '100%',
  height = 280,
  prefix = '',
  suffix = '',
  decimalPoints = 0,
  yAxisDecimalPoints = 0,
}) {
  const options = {
    title: { text: title },
    chart: {
      stacked: true,
      animations: {
        enabled: false,
      },
    },
    xaxis: {
      categories,
      labels: {
        offsetY: 5,
        rotate: -45,
        rotateAlways: true,
      },
    },
    yaxis: [
      {
        forceNiceScale: true,
        showForNullSeries: false,
        labels: {
          formatter: (value) => `${prefix}${value?.toLocaleString(undefined, { maximumFractionDigits: yAxisDecimalPoints })}${suffix}`,
        },
        title: {
          text: '',
        },
      },
    ],
    grid: {
      padding: { left: 10 },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 0,
    },
    markers: {
      size: 0,
      strokeWidth: 0,
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => `${prefix}${val.toLocaleString(undefined, { maximumFractionDigits: decimalPoints })}${suffix}`,
      },
    },
    legend: {
      showForNullSeries: false,
      showForSingleSeries: true,
      clusterGroupedSeries: true,
    },
  };

  return <Chart options={options} series={series} type="bar" width={width} height={height} />;
}

export default StackedBarChart;
